// View CRM Details for one CRM 2.0 booking, opened from a bell row (M1-F8, design §8.2).
// Reads the booking in today's CRM list shape (getOldCrmRow) and opens today's pop-up, as the
// CRM 2.0 page ⋮ menu does. Rendered outside the bell drawer, so it stays open when the drawer
// closes. While the booking loads a small spinner shows; a click on it cancels.
import React, { useEffect, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import ViewAllotedCrmDetailsModal from "../../AllAllotments/CrmAllotment/ViewAllotedCrmDetailsModal/ViewAllotedCrmDetailsModal";
import { getOldCrmRow } from "../../../Services/Crm2List";
import { errorTost } from "../../../Services/Toast";
import { crmDetailsObject } from "../ui/crmDetailsRow";

function Crm2BookingDetails({ allotmentPaymentId, onClose }) {
  const [row, setRow] = useState(null);

  useEffect(() => {
    let alive = true;
    setRow(null);
    getOldCrmRow({ allotmentPaymentId })
      .then((r) => {
        if (!alive) return;
        if (!r) {
          errorTost("Could not open this booking. Please refresh and try again.");
          onClose();
          return;
        }
        setRow(r);
      })
      .catch((err) => {
        if (!alive) return;
        console.error("[crm2][bell] View CRM Details failed", { allotmentPaymentId, error: err?.message });
        errorTost("Could not open this booking. Please try again.");
        onClose();
      });
    return () => {
      alive = false;
    };
    // onClose is a new function on every parent render; the booking id alone decides what to load
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allotmentPaymentId]);

  if (!row) {
    return (
      <Backdrop open sx={{ zIndex: 1400, color: "#FFFFFF" }} onClick={onClose}>
        <CircularProgress color="inherit" aria-label="Opening the booking" />
      </Backdrop>
    );
  }
  return <ViewAllotedCrmDetailsModal open selectedAllotmentObject={crmDetailsObject(row)} handleClose={onClose} />;
}

export default Crm2BookingDetails;
